var App = App || {};

App.HamburgerNav = (function ($) {
    "use strict";

    var $hamburger,
        $toggle,
        $alertHeight,
        $headerHeight,
        _isOpen;

    function init() {
        $hamburger = $('#mobile-menu');
        $toggle = $('.mobile-menu__toggle');
        $('.mobile-menu__toggle > button').on('click', toggleMenu);


        $hamburger.find(".accordion-collapse").on('shown.bs.collapse', function () {
            $(this).parent(".accordion-item").addClass("open");
        });

        $hamburger.find(".accordion-collapse").on('hidden.bs.collapse', function () {
            $(this).parent(".accordion-item").removeClass("open");
        });
    }

    function toggleMenu() {
        _isOpen ? closeMenu() : openMenu();
    }

    function openMenu() {
        $alertHeight = $("#site-alerts").length !== 0 ? $("#site-alerts").outerHeight() : 0;
        $headerHeight = $("#site-header").outerHeight() + $alertHeight;

        if (document.documentElement.clientHeight < 400) {
            $headerHeight = $("#site-header").outerHeight();
            $("#site-alerts").hide();
        }

        if (App.Login.isOpen()) {
            App.Login.closeLogin();
        }

        $toggle
            .addClass('open');

        $hamburger.css("top", $headerHeight + "px");
        $(".site-header-primary-mobile").find(".offcanvas-backdrop").css("top", $headerHeight + "px");
        _isOpen = true;
    }

    function closeMenu() {
        $toggle
            .removeClass('open')
        _isOpen = false;

        if (document.documentElement.clientHeight < 400) {
            $("#site-alerts").show();
        }
    }

    function alertDismiss() {
        $alertHeight = $("#site-alerts").length !== 0 ? $("#site-alerts").outerHeight() : 0;
        $headerHeight = $("#site-header").outerHeight() + $alertHeight;

        if (_isOpen) {
            $hamburger.css("top", $headerHeight + "px");
        }
    }


    return {
        init: init,
        closeMenu: closeMenu,
        alertDismiss: alertDismiss,
        isOpen: function () { return _isOpen; }
    };
})(jQuery);

$(function () {
    App.HamburgerNav.init();
});